import { axios, axiosWithToken } from './axios';

export const fetchGetTermsVersion = async () => {
  const response = await axios.get(`app/portal/terms`);

  return JSON.parse(response.data.body).version;
};

export const getAppVersion = async () => {
  const response = await axiosWithToken.get('app/version');

  return response.data.version;
};
